import React from "react";
import { MODELS_TAB, STRATEGIES_TAB } from "../Commend3Constants";

type Commend3TabsProps = {
  activeTab: string;
  onChange: (tabId: string) => void;
};

const TABS = [
  { id: MODELS_TAB, label: "Models" },
  { id: STRATEGIES_TAB, label: "Strategies" },
];

const Commend3Tabs = ({ activeTab, onChange }: Commend3TabsProps) => (
  <div
    id="commend3-tabs"
    className="tw-flex tw-shrink-0 tw-bg-white tw-px-[22px]"
    style={{ borderBottom: "0.5px solid #E3E5EC" }}
  >
    {TABS.map((tab) => {
      const on = tab.id === activeTab;
      return (
        <div
          key={tab.id}
          id={`commend3-tab-${tab.id}`}
          role="button"
          tabIndex={0}
          className="tw-cursor-pointer tw-px-[14px] tw-py-[11px] tw-text-[13px] tw-font-medium"
          style={{
            color: on ? "#030562" : "#59596E",
            borderBottom: `2px solid ${on ? "#030562" : "transparent"}`,
            marginBottom: "-0.5px",
          }}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </div>
      );
    })}
  </div>
);

export default Commend3Tabs;
